// src/components/charts/ProductPerformanceLineChart.jsx
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler, // Import Filler for area charts if desired
} from 'chart.js';

// Register the necessary components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const ProductPerformanceLineChart = ({ chartData, title = "Product Performance" }) => {
  if (!chartData || !chartData.labels || chartData.labels.length === 0) {
    return (
      <div className="w-full h-64 flex items-center justify-center bg-gray-50 rounded border border-dashed border-gray-300">
        <p className="text-gray-500">No performance data available for the selected period.</p>
      </div>
    );
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allows height to be controlled by container
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 10,
          font: {
            size: 10,
          }
        }
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 14,
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Hide vertical grid lines
        },
        ticks: {
          maxRotation: 0, // Prevent label rotation
          autoSkip: true, // Automatically skip labels if too crowded
          maxTicksLimit: 7 // Limit the number of visible x-axis labels
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#e5e7eb', // Lighter grid lines
          borderDash: [3, 3], // Dashed lines
        },
        ticks: {
           // Optional: format y-axis ticks if needed
           // callback: function(value) { return value.toLocaleString(); }
        }
      },
    },
    elements: {
      line: {
        tension: 0.3, // Smoother lines
      },
      point: {
        radius: 3, // Smaller points
        hoverRadius: 5,
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    }
  };

  // Data structure expected by react-chartjs-2
  const data = {
    labels: chartData.labels, // Array of dates/time points
    datasets: [
      {
        label: 'Views', // Or Traffic, Sales, etc.
        data: chartData.values, // Array of corresponding values
        borderColor: 'rgb(79, 70, 229)', // Indigo color
        backgroundColor: 'rgba(79, 70, 229, 0.1)', // Light indigo fill
        fill: true, // Fill area under the line
        borderWidth: 2,
        pointBackgroundColor: 'rgb(79, 70, 229)',
      },
      // Add more datasets here if needed (e.g., for comparing metrics)
      // {
      //   label: 'CTR',
      //   data: chartData.ctrValues,
      //   borderColor: 'rgb(5, 150, 105)', // Green color
      //   backgroundColor: 'rgba(5, 150, 105, 0.1)',
      //   fill: false, // Don't fill area for CTR line
      //   yAxisID: 'y1', // Use a secondary y-axis if scales differ significantly
      // },
    ],
  };

  return (
    <div className="w-full h-64 md:h-72 lg:h-80"> {/* Adjust height as needed */}
      <Line options={options} data={data} />
    </div>
  );
};

export default ProductPerformanceLineChart;
